export default [
  { key: 'AF', description: 'Afghanistan' },
  { key: 'AX', description: 'Aland Islands' },
  { key: 'AL', description: 'Albania' },
  { key: 'DZ', description: 'Algeria' },
  { key: 'AS', description: 'American Samoa' },
  { key: 'AD', description: 'Andorra' },
  { key: 'AO', description: 'Angola' },
  { key: 'AI', description: 'Anguilla' },
  { key: 'AQ', description: 'Antarctica' },
  { key: 'AG', description: 'Antigua and Barbuda' },
  { key: 'AR', description: 'Argentina' },
  { key: 'AM', description: 'Armenia' },
  { key: 'AW', description: 'Aruba' },
  { key: 'AU', description: 'Australia' },
  { key: 'AT', description: 'Austria' },
  { key: 'AZ', description: 'Azerbaijan' },
  { key: 'BS', description: 'Bahamas' },
  { key: 'BH', description: 'Bahrain' },
  { key: 'BD', description: 'Bangladesh' },
  { key: 'BB', description: 'Barbados' },
  { key: 'BY', description: 'Belarus' },
  { key: 'BE', description: 'Belgium' },
  { key: 'BZ', description: 'Belize' },
  { key: 'BJ', description: 'Benin' },
  { key: 'BM', description: 'Bermuda' },
  { key: 'BT', description: 'Bhutan' },
  { key: 'BO', description: 'Bolivia' },
  { key: 'BA', description: 'Bosnia and Herzegovina' },
  { key: 'BW', description: 'Botswana' },
  { key: 'BV', description: 'Bouvet Island' },
  { key: 'BR', description: 'Brazil' },
  { key: 'IO', description: 'British Indian Ocean Territory' },
  { key: 'BN', description: 'Brunei Darussalam' },
  { key: 'BG', description: 'Bulgaria' },
  { key: 'BF', description: 'Burkina Faso' },
  { key: 'BI', description: 'Burundi' },
  { key: 'KH', description: 'Cambodia' },
  { key: 'CM', description: 'Cameroon' },
  { key: 'CA', description: 'Canada' },
  { key: 'CV', description: 'Cape Verde' },
  { key: 'KY', description: 'Cayman Islands' },
  { key: 'CF', description: 'Central African Republic' },
  { key: 'TD', description: 'Chad' },
  { key: 'CL', description: 'Chile' },
  { key: 'CN', description: 'China' },
  { key: 'CX', description: 'Christmas Island' },
  { key: 'CC', description: 'Cocos (KeelingIslands)' },
  { key: 'CO', description: 'Colombia' },
  { key: 'KM', description: 'Comoros' },
  { key: 'CG', description: 'Congo' },
  { key: 'CD', description: 'Congo, DR' },
  { key: 'CK', description: 'Cook Islands' },
  { key: 'CR', description: 'Costa Rica' },
  { key: 'CI', description: 'Cote D\'Ivoire' },
  { key: 'HR', description: 'Croatia' },
  { key: 'CU', description: 'Cuba' },
  { key: 'CY', description: 'Cyprus' },
  { key: 'CZ', description: 'Czech Republic' },
  { key: 'DK', description: 'Denmark' },
  { key: 'DJ', description: 'Djibouti' },
  { key: 'DM', description: 'Dominica' },
  { key: 'DO', description: 'Dominican Republic' },
  { key: 'EC', description: 'Ecuador' },
  { key: 'EG', description: 'Egypt' },
  { key: 'SV', description: 'El Salvador' },
  { key: 'GQ', description: 'Equatorial Guinea' },
  { key: 'ER', description: 'Eritrea' },
  { key: 'EE', description: 'Estonia' },
  { key: 'ET', description: 'Ethiopia' },
  { key: 'FK', description: 'Falkland Islands (Malvinas)' },
  { key: 'FO', description: 'Faroe Islands' },
  { key: 'FJ', description: 'Fiji' },
  { key: 'FI', description: 'Finland' },
  { key: 'FR', description: 'France' },
  { key: 'GF', description: 'French Guiana' },
  { key: 'PF', description: 'French Polynesia' },
  { key: 'TF', description: 'French Southern Territories' },
  { key: 'GA', description: 'Gabon' },
  { key: 'GM', description: 'Gambia' },
  { key: 'GE', description: 'Georgia' },
  { key: 'DE', description: 'Germany' },
  { key: 'GH', description: 'Ghana' },
  { key: 'GI', description: 'Gibraltar' },
  { key: 'GR', description: 'Greece' },
  { key: 'GL', description: 'Greenland' },
  { key: 'GD', description: 'Grenada' },
  { key: 'GP', description: 'Guadeloupe' },
  { key: 'GU', description: 'Guam' },
  { key: 'GT', description: 'Guatemala' },
  { key: 'GG', description: 'Guernsey' },
  { key: 'GN', description: 'Guinea' },
  { key: 'GW', description: 'Guinea-Bissau' },
  { key: 'GY', description: 'Guyana' },
  { key: 'HT', description: 'Haiti' },
  { key: 'HM', description: 'Heard Island and Mcdonald Islands' },
  { key: 'VA', description: 'Holy See (Vatican City State)' },
  { key: 'HN', description: 'Honduras' },
  { key: 'HK', description: 'Hong Kong' },
  { key: 'HU', description: 'Hungary' },
  { key: 'IS', description: 'Iceland' },
  { key: 'IN', description: 'India' },
  { key: 'ID', description: 'Indonesia' },
  { key: 'IR', description: 'Islamic Republic of Iran' },
  { key: 'IQ', description: 'Iraq' },
  { key: 'IE', description: 'Ireland' },
  { key: 'IM', description: 'Isle of Man' },
  { key: 'IL', description: 'Israel' },
  { key: 'IT', description: 'Italy' },
  { key: 'JM', description: 'Jamaica' },
  { key: 'JP', description: 'Japan' },
  { key: 'JE', description: 'Jersey' },
  { key: 'JO', description: 'Jordan' },
  { key: 'KZ', description: 'Kazakhstan' },
  { key: 'KE', description: 'Kenya' },
  { key: 'KI', description: 'Kiribati' },
  { key: 'KR', description: 'South Korea' },
  { key: 'KW', description: 'Kuwait' },
  { key: 'KG', description: 'Kyrgyzstan' },
  { key: 'LA', description: 'Laos' },
  { key: 'LV', description: 'Latvia' },
  { key: 'LB', description: 'Lebanon' },
  { key: 'LS', description: 'Lesotho' },
  { key: 'LR', description: 'Liberia' },
  { key: 'LY', description: 'Libyan Arab Jamahiriya' },
  { key: 'LI', description: 'Liechtenstein' },
  { key: 'LT', description: 'Lithuania' },
  { key: 'LU', description: 'Luxembourg' },
  { key: 'ME', description: 'Montenegro' },
  { key: 'MO', description: 'Macau' },
  { key: 'MK', description: 'The Former Yugoslav Republic of Macedonia' },
  { key: 'MG', description: 'Madagascar' },
  { key: 'MW', description: 'Malawi' },
  { key: 'MY', description: 'Malaysia' },
  { key: 'MV', description: 'Maldives' },
  { key: 'ML', description: 'Mali' },
  { key: 'MT', description: 'Malta' },
  { key: 'MH', description: 'Marshall Islands' },
  { key: 'MQ', description: 'Martinique' },
  { key: 'MR', description: 'Mauritania' },
  { key: 'MU', description: 'Mauritius' },
  { key: 'YT', description: 'Mayotte' },
  { key: 'MX', description: 'Mexico' },
  { key: 'FM', description: 'Federated States of Micronesia' },
  { key: 'MD', description: 'Republic of Moldova' },
  { key: 'MC', description: 'Monaco' },
  { key: 'MN', description: 'Mongolia' },
  { key: 'MS', description: 'Montserrat' },
  { key: 'MA', description: 'Morocco' },
  { key: 'MZ', description: 'Mozambique' },
  { key: 'MM', description: 'Myanmar' },
  { key: 'NA', description: 'Namibia' },
  { key: 'NR', description: 'Nauru' },
  { key: 'NP', description: 'Nepal' },
  { key: 'NL', description: 'Netherlands' },
  { key: 'AN', description: 'Netherlands Antilles' },
  { key: 'NC', description: 'New Caledonia' },
  { key: 'NZ', description: 'New Zealand' },
  { key: 'NI', description: 'Nicaragua' },
  { key: 'NE', description: 'Niger' },
  { key: 'NG', description: 'Nigeria' },
  { key: 'NU', description: 'Niue' },
  { key: 'NF', description: 'Norfolk Island' },
  { key: 'MP', description: 'Northern Mariana Islands' },
  { key: 'KP', description: 'North Korea' },
  { key: 'NO', description: 'Norway' },
  { key: 'OM', description: 'Oman' },
  { key: 'PK', description: 'Pakistan' },
  { key: 'PW', description: 'Palau' },
  { key: 'PS', description: 'Palestinian Territory, Occupied' },
  { key: 'PA', description: 'Panama' },
  { key: 'PG', description: 'Papua New Guinea' },
  { key: 'PY', description: 'Paraguay' },
  { key: 'PE', description: 'Peru' },
  { key: 'PH', description: 'Philippines' },
  { key: 'PN', description: 'Pitcairn' },
  { key: 'PL', description: 'Poland' },
  { key: 'PT', description: 'Portugal' },
  { key: 'PR', description: 'Puerto Rico' },
  { key: 'QA', description: 'Qatar' },
  { key: 'RE', description: 'Reunion' },
  { key: 'RO', description: 'Romania' },
  { key: 'RS', description: 'Serbia' },
  { key: 'RU', description: 'Russian Federation' },
  { key: 'RW', description: 'RWANDA' },
  { key: 'SH', description: 'Saint Helena' },
  { key: 'KN', description: 'Saint Kitts and Nevis' },
  { key: 'LC', description: 'Saint Lucia' },
  { key: 'PM', description: 'Saint Pierre and Miquelon' },
  { key: 'VC', description: 'Saint Vincent and the Grenadines' },
  { key: 'WS', description: 'Samoa' },
  { key: 'SM', description: 'San Marino' },
  { key: 'ST', description: 'Sao Tome and Principe' },
  { key: 'SA', description: 'Saudi Arabia' },
  { key: 'SN', description: 'Senegal' },
  { key: 'SC', description: 'Seychelles' },
  { key: 'SL', description: 'Sierra Leone' },
  { key: 'SG', description: 'Singapore' },
  { key: 'SK', description: 'Slovakia' },
  { key: 'SI', description: 'Slovenia' },
  { key: 'SB', description: 'Solomon Islands' },
  { key: 'SO', description: 'Somalia' },
  { key: 'ZA', description: 'South Africa' },
  { key: 'GS', description: 'South Georgia' },
  { key: 'ES', description: 'Spain' },
  { key: 'LK', description: 'Sri Lanka' },
  { key: 'SD', description: 'Sudan' },
  { key: 'SR', description: 'Suriname' },
  { key: 'SJ', description: 'Svalbard and Jan Mayen' },
  { key: 'SZ', description: 'Swaziland' },
  { key: 'SE', description: 'Sweden' },
  { key: 'CH', description: 'Switzerland' },
  { key: 'SY', description: 'Syrian Arab Republic' },
  { key: 'TW', description: 'Taiwan, Province of China' },
  { key: 'TJ', description: 'Tajikistan' },
  { key: 'TZ', description: 'Tanzania' },
  { key: 'TH', description: 'Thailand' },
  { key: 'TL', description: 'Timor-Leste' },
  { key: 'TG', description: 'Togo' },
  { key: 'TK', description: 'Tokelau' },
  { key: 'TO', description: 'Tonga' },
  { key: 'TT', description: 'Trinidad and Tobago' },
  { key: 'TN', description: 'Tunisia' },
  { key: 'TR', description: 'Turkey' },
  { key: 'TM', description: 'Turkmenistan' },
  { key: 'TC', description: 'Turks and Caicos Islands' },
  { key: 'TV', description: 'Tuvalu' },
  { key: 'UG', description: 'Uganda' },
  { key: 'UA', description: 'Ukraine' },
  { key: 'AE', description: 'United Arab Emirates' },
  { key: 'GB', description: 'United Kingdom' },
  { key: 'US', description: 'United States' },
  { key: 'UY', description: 'Uruguay' },
  { key: 'UZ', description: 'Uzbekistan' },
  { key: 'VU', description: 'Vanuatu' },
  { key: 'VE', description: 'Venezuela' },
  { key: 'VN', description: 'Viet Nam' },
  { key: 'VG', description: 'Virgin Islands, British' },
  { key: 'VI', description: 'Virgin Islands, U.S.' },
  { key: 'WF', description: 'Wallis and Futuna' },
  { key: 'EH', description: 'Western Sahara' },
  { key: 'YE', description: 'Yemen' },
  { key: 'ZM', description: 'Zambia' },
  { key: 'ZW', description: 'Zimbabwe' }
]
